var map = {
	"./forest-poster.jpg": "3yQ6",
	"./ocean-poster.jpg": "ZI6r"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1g8w";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\-poster\.jpg$
// module id = 1g8w
// module chunks = 1